import { API_STATUS } from "../../../constants/apiStatus";

export const mealsSliceInitialState = {
  meals: [],
  userMeals: [],
  selectedMeal: null,
  apiStatus: {
    getAllMeals: API_STATUS.IDLE,
    getUserMeals: API_STATUS.IDLE,
    getMealById: API_STATUS.IDLE,
    createMeal: API_STATUS.IDLE,
    updateMeal: API_STATUS.IDLE,
    deleteMeal: API_STATUS.IDLE,
  },
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalMeals: 0,
    limit: 10,
  },
  error: null,
};
